import { FileDocumentPlusIcon } from './FileDocumentPlusIcon';

/**
 * author: Simran
 * id 2382A261-E45B-429D-A2E2-29DA654064E1
 * name file-document-plus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-plus.svg
 * tags
 * - Files / Folders 
 */
export const FileTextAddIcon = FileDocumentPlusIcon;
export default FileTextAddIcon